import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesQuotasComponent} from "./sales-quotas.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";



@NgModule({
  declarations: [
    SalesQuotasComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule
  ],
  exports: [
    SalesQuotasComponent
  ]
})
export class SalesQuotasModule { }
